import PrimaryMenuItem from '../model/PrimaryMenuItem.js';
import SecondaryMenuItem from '../model/SecondaryMenuItem';
import TertiaryMenuItem from '../model/TertiaryMenuItem';

// 第一層
const chatbot = new PrimaryMenuItem('Chatbot', 'psychology');

// 第二層
const chatbotSetting = new SecondaryMenuItem('ChatbotSetting');
const knowledgeSetting = new SecondaryMenuItem('KnowledgeSetting');
const intelligentQualityInspection = new SecondaryMenuItem('IntelligentQualityInspection');

// 註冊第二層
chatbot.RegisterChild(chatbotSetting);
chatbot.RegisterChild(knowledgeSetting);
chatbot.RegisterChild(intelligentQualityInspection);

// 第三層
const chatbotParamSetting = new TertiaryMenuItem('ChatbotParamSetting', () => import('@/modules/gss/views/ChatbotParamSetting.vue'));
const knowledgeCategorySetting = new TertiaryMenuItem('KnowledgeCategorySetting', () => import('@/modules/kcs/views/List.vue'));
const vocabularyManage = new TertiaryMenuItem('VocabularyManage', () => import('@/modules/vms/views/List.vue'));
const aQuestionManage = new TertiaryMenuItem('AQuestionManage', () => import('@/modules/qas/views/List.vue'));
const knowledgeDeleted = new TertiaryMenuItem('KnowledgeDeleted', () => import('@/modules/qas/views/DeleteList.vue'));
const preciseNavigationDialogue = new TertiaryMenuItem('PreciseNavigationDialogue', () => import('@/modules/qas/views/ClassList.vue'));
const preciseNavigationDeleted = new TertiaryMenuItem('PreciseNavigationDeleted', () => import('@/modules/qas/views/DeleteClassList.vue'));
const learningList = new TertiaryMenuItem('LearningList', () => import('@/modules/qas/views/LearningList.vue'));
const dialogueQualityManagement = new TertiaryMenuItem('DialogueQualityManagement', () => import('@/modules/dialogue-quality-management/views/List.vue'));
// 註冊第三層
chatbotSetting.RegisterChild(chatbotParamSetting);
knowledgeSetting.RegisterChild(knowledgeCategorySetting);
knowledgeSetting.RegisterChild(vocabularyManage);
knowledgeSetting.RegisterChild(aQuestionManage);
knowledgeSetting.RegisterChild(knowledgeDeleted);
knowledgeSetting.RegisterChild(preciseNavigationDialogue);
knowledgeSetting.RegisterChild(preciseNavigationDeleted);
knowledgeSetting.RegisterChild(learningList);
intelligentQualityInspection.RegisterChild(dialogueQualityManagement);
export default chatbot;
